const files = require.context('.', false, /\.js$/)
const modules = []

files.keys().forEach(key => {
  if (key === './index.js') return
  modules.push(files(key))
})

const modulesByWeight = modules.sort((m1, m2) => m2.weight - (+m1.weight || 0))
const modulesFunctions = modulesByWeight.map(m => m.default)

export default modulesFunctions
